<template>
  <div>
    <v-dialog v-model="dialog" persistent eager scrollable max-width="1000px">
      <v-form ref="SupportFunction" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>{{ action }} OPCR Support Function</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <v-col cols="12" v-if="action == 'Add'">
                  <v-autocomplete
                    v-model="selectedType"
                    :rules="[formRules.required]"
                    dense
                    outlined
                    label="Type"
                    @change="changeType()"
                    class="rounded-lg"
                    item-text="description"
                    item-value="id"
                    color="#93CB5B"
                    :items="selectionList"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" v-if="selectedType == 2 && action == 'Add'">
                  <v-autocomplete
                    v-model="selectedPrevYear"
                    :rules="[formRules.required]"
                    dense
                    outlined
                    label="Select Previous Year's Support Function to Replicate"
                    @change="setYear()"
                    class="rounded-lg"
                    item-text="year"
                    item-value="year"
                    color="#93CB5B"
                    :items="prevYear"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Year"
                    readonly
                    outlined
                    v-model="year"
                    dense
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="selectedType == 1">
                  <v-textarea
                    label="MFO"
                    outlined
                    v-model="mfo"
                    :readonly="action == 'View'"
                    dense
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" v-if="selectedType == 1">
                  <v-textarea
                    label="Success Indicator"
                    outlined
                    :readonly="action == 'View'"
                    v-model="success_indicator"
                    dense
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>

                <!-- <v-col cols="12" v-if="selectedType == 1" >
                  <v-textarea
                    label="Actual Accomplishment"
                    outlined
                    :readonly="action == 'View'"
                    :rules="selectedType == 1 ? [formRules.required] : []"
                    v-model="actual_accom"
                    dense
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col> -->

                <v-col cols="12" class=" mt-4" v-if="selectedType == 1">
                  <div class="rounded-lg  pa-3" style="border:1px solid gray;">
                    <div class="h3 mb-2">
                      Rating (<i>Uncheck if <b>Not to be Rated</b></i> )
                    </div>
                    <v-row>
                      <v-col
                        cols="4"
                        class="d-flex justify-center align-center"
                      >
                        <v-checkbox
                          v-model="eff_is_rated"
                          label="(E) - Efficiency"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="4"
                        class="d-flex justify-center align-center"
                      >
                        <v-checkbox
                          v-model="qly_is_rated"
                          label="(Q) - Quality"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="4"
                        class="d-flex justify-center align-center"
                      >
                        <v-checkbox
                          v-model="timeliness_is_rated"
                          label="(T) - Timeliness"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>

            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>

            <v-btn
              v-if="action == 'Add'"
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              @click="addnew()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
            <v-btn
              v-if="action == 'Update'"
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              @click="update()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              <v-icon>mdi-check-circle</v-icon>
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    target_type: null,
    action: null,
  },

  data() {
    return {
      id: null,
      selectedType: null,
      success_indicator: null,
      eff_is_rated: true,
      qly_is_rated: true,
      actual_accom: null,
      timeliness_is_rated: true,
      dialog: false,
      isSubmitLoading: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      selectionList: [
        { id: 1, description: "Create New" },
        { id: 2, description: "Replicate Previous Year's Support Function" },
      ],
      year: null,
      mfo: null,
      mfoDescription: null,
      prevYear: [],
      selectedPrevYear: null,
    };
  },
  computed: {
    filterYear() {
      return this.$store.getters.getFilterSelected;
    },
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;

        if (data.id) {
          this.id = data.id;
          if (this.action != "Add") {
            this.year = data.year;
            this.selectedType = 1;
            this.mfo = data.mfo;
            this.actual_accom = data.actual_accom;
            this.success_indicator = data.success_indicator;
          }
          // this.selectedType = parseInt(data.selectedType);
          // this.actual_accom = data.actual_accom;
          // if (data.selectedType == 1) {
          //   this.success_indicator = data.success_indicator;
          // } else {
          //   this.success_indicator = data.suc_ind;
          // }

          this.eff_is_rated = data.eff_is_rated;
          this.qly_is_rated = data.qly_is_rated;
          this.timeliness_is_rated = data.timeliness_is_rated;
        } else {
          this.id = null;
          this.selectedType = 1;
          if (this.filterYear != "All") {
            this.year = this.filterYear;
          } else {
            let d = new Date();
            this.year = d.getFullYear();
          }
          this.actual_accom = null;
          this.success_indicator = null;
          this.eff_is_rated = 1;
          this.qly_is_rated = 1;
          this.timeliness_is_rated = 1;
        }
      },

      deep: true,
    },
  },

  methods: {
    initialize() {},

    closeD() {
      this.eventHub.$emit("closeOPCRSFUtilDialog", false);
      this.initialize();
      this.isSubmitLoading = false;
      this.dialog = false;
    },

    changeType() {
      if (this.selectedType == 1) {
        if (this.filterYear != "All") {
          this.year = this.filterYear;
        } else {
          let d = new Date();
          this.year = d.getFullYear();
        }
      } else {
        this.year = null;
        this.loadPrevYearOfSF();
      }
    },

    setYear() {
      this.year = parseInt(this.selectedPrevYear) + 1;
    },

    loadPrevYearOfSF() {
      this.axiosCall("/opcr-support-util/getPrevYears/years", "GET").then(
        (res) => {
          console.log(res.data);
          this.prevYear = res.data;
        }
      );
    },

    addnew() {
      if (this.$refs.SupportFunction.validate()) {
        this.isSubmitLoading = true;
        let data = {
          mfo: this.mfo,
          success_indicator: this.success_indicator,
          actual_accom: this.actual_accom,
          eff_is_rated: this.eff_is_rated,
          qly_is_rated: this.qly_is_rated,
          timeliness_is_rated: this.timeliness_is_rated,
          typeOfAdding: this.selectedType,
          yearToReplicate: this.selectedPrevYear,
          yearToSave: this.year,
        };
        // console.log(data);
        this.axiosCall("/opcr-support-util", "POST", data).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;

            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.isSubmitLoading = false;
          }
        });
      }
    },

    update() {
      if (this.$refs.SupportFunction.validate()) {
        this.isSubmitLoading = true;
        let data = {
          mfo: this.mfo,
          success_indicator: this.success_indicator,
          actual_accom: this.actual_accom,
          selectedType: this.selectedType,
          eff_is_rated: this.eff_is_rated,
          qly_is_rated: this.qly_is_rated,
          timeliness_is_rated: this.timeliness_is_rated,
        };
        // console.log(data);
        this.axiosCall("/opcr-support-util/" + this.id, "PATCH", data).then(
          (res) => {
            if (res.data.status == 200) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.closeD();
            } else {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          }
        );
      }
    },
  },
};
</script>
